import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom"
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import ResponseIcon from '@material-ui/icons/Comment'
import AccountBoxIcon from '@material-ui/icons/AccountCircle'
import SendIcon from '@material-ui/icons/Send'
import { makeStyles } from '@material-ui/core/styles'
import CKEditor from 'ckeditor4-react'
import ckeditorConfig from '../../utils/ckeditor'
import Collapse from '@material-ui/core/Collapse'
import { userQueries } from '../../graphql/queries'
import { forumMutations } from '../../graphql/mutations'
import { useQuery, useMutation } from '@apollo/react-hooks'
import Typography from '@material-ui/core/Typography'
import { useSnackbar } from 'notistack'
import PriorityHighTwoToneIcon from '@material-ui/icons/PriorityHighTwoTone';

const useStyles = makeStyles({
  root: {
    paddingTop: 21,
    paddingBottom: 21
  },
  responseButton: {
    marginBottom: 20,
    color: '#fff'
  },
  nickname: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '.3em'
  },
  accountIcon: {
    marginRight: 5
  },
  formFooter: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: 10
  },
  sendButton: {
      color: '#fff',
      marginLeft: 10
  }
})

const ResponseForm = ({ curso_id, topico_id, resposta_id, query }) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [openPerfil, setOpenPerfil] = useState(false)
  const [response, setResponse] = useState('')
  const { enqueueSnackbar } = useSnackbar()
  const { data: dataUser } = useQuery(userQueries.GET_USER)
  const [respondeTopicoForum]  = useMutation(forumMutations.RESPONDE_TOPICO_FORUM, {
    refetchQueries: [query],
    onCompleted: () => {
      enqueueSnackbar('Resposta enviada com sucesso.')
      setOpen(false)
    }
  })
  const [respondeRespostaTopico]  = useMutation(forumMutations.RESPONDE_RESPOSTA_FORUM, {
    refetchQueries: [query],
    onCompleted: () => {
      enqueueSnackbar('Resposta enviada com sucesso.')
      setOpen(false)
    }
  })

  let history = useHistory()
  const routeChange = () =>{    
    history.push("/meu-perfil")
  } 

  const toggleOpen = () => {

    if(((dataUser || {}).usuario || {}).apelido && ((dataUser || {}).usuario || {}).apelido != "None" ){
      setOpen(!open)
    }else{      
      setOpenPerfil(!openPerfil)
    }
   
  }

  useEffect(() => {
    if(open !== '') {
      setResponse('')
    }
  }, [open])

  const apelido = ((dataUser || {}).usuario || {}).apelido || 'Eu'
  const sendResponse = () => {
    if(resposta_id) {
      respondeRespostaTopico({ variables: { descricao: response, resposta_id, topico_id, curso_id } })
    } else {
      respondeTopicoForum({ variables: { descricao: response, topico_id, curso_id } })
    }
  }

  return (
    <div className={classes.root}>      
      <Collapse in={!open}>
        <Button onClick={toggleOpen} className={classes.responseButton} startIcon={<ResponseIcon />} color={'secondary'} variant={'contained'}>
          Responder
        </Button>
      </Collapse>
      <Collapse in={open} className={classes.responseCard}>
          <Typography variant={'h5'} >Resposta</Typography>
        <Typography className={classes.nickname}>
          <AccountBoxIcon className={classes.accountIcon} />
          {apelido}
        </Typography>
        <FormControl style={{ width: '100%', zIndex: 3, margin: 0 }}>
          <CKEditor
            id="field-detalhes-aula"
            data={response.replace(/<math>|<\/math>/gi, '`')}
            config={ckeditorConfig}
            onChange={(event, editor) => {
              setResponse(event.editor.getData())
            }}
          />
        </FormControl>
        <div className={classes.formFooter}>
            <Button onClick={toggleOpen} color={'default'} variant={'contained'}>
              Cancelar
            </Button>
            <Button disabled={!response} className={classes.sendButton} onClick={sendResponse} startIcon={<SendIcon />} color={'secondary'} variant={'contained'}>
              Enviar
            </Button>
        </div>
      </Collapse>

      <Collapse in={openPerfil} className={classes.responseCard} style={{textAlign: 'center'}}>
          <div style={{backgroundColor: '#DCDCDC'	}} >
          <p><PriorityHighTwoToneIcon style={{color: 'red'}}  fontSize="large" /></p>
          <p>Usuário sem apelido.</p>
          <p>Atualize seu perfil para responder.</p>

          <Button color="primary" className="px-4"onClick={routeChange} >
              Acesse aqui para atualizar
          </Button>
          </div>
      </Collapse>





    </div>
  )
}

export default ResponseForm
